/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

import FileDownload from 'js-file-download';
import swal from 'sweetalert';
import {handle_error} from '@/components/application-level/helper-components/error_handler';
import axios from 'axios';

// export function valueFormatter(value, n_digits) {
//   return value.toFixed(n_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ';');
// }

export function format_ad_valorem(val) {
  if (val === -1 || val === -0.01) return '-';
  if (val === -2 || val === -0.02) return 'NA';
  if (val >= 0) return ((parseFloat(val) * 100 * 100) / 100).toFixed(2);
  return '0.00';
}

export function html_to_xls_download(table_id, extra_text = '') {
  let table_html = document
    .getElementById(table_id)
    .getElementsByClassName('v-data-table__wrapper')[0].innerHTML;

  let table_headers = document
    .getElementById(table_id)
    .getElementsByClassName('v-data-table__wrapper')[0]
    .getElementsByTagName('TH');

  table_headers = Array.from(table_headers).map(v => v.innerText);

  // filters
  let filter_html = '';
  let filter_headers = '';
  try {
    filter_html = document
      .getElementById('results_current_filters')
      .getElementsByClassName('v-data-table__wrapper')[0].innerHTML;
    filter_headers = document
      .getElementById('results_current_filters')
      .getElementsByClassName('v-data-table__wrapper')[0]
      .getElementsByTagName('TH');
    filter_headers = Array.from(filter_headers).map(v => v.innerText);
  } catch (e) {
    console.log(e);
    filter_html = '';
    filter_headers = '';
  }

  ///

  this.axios({
    method: 'post',
    baseURL: this.$store.getters.baseUrl,
    url: 'table_to_excel/',
    responseType: 'blob',
    data: {
      table_html: table_html,
      table_headers: table_headers,
      filter_html: filter_html,
      filter_headers: filter_headers,
      sheet_name: table_id,
    },
  })
    .then(response => {
      const filename = `${table_id}${extra_text}.xlsx`;
      FileDownload(response.data, filename);
      swal('CSV downloaded to downloads folder.', {
        buttons: false,
        timer: 2000,
      });
    })
    .catch(e => {
      handle_error({
        code: 'html_to_xls_download_error',
        message: e.message,
      });
    });
}

export function csvExport(filename, dataArray) {
  let csvContent = 'data:text/csv;charset=utf-8,';
  const arrData = dataArray.slice(0, 1000);
  csvContent += [
    Object.keys(arrData[0]).join(';'),
    ...arrData.map(item => Object.values(item).join(';')),
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '');

  const data = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  link.click();
}

export function csvExportREO(filename, dataArray) {
  let csvContent = 'data:text/csv;charset=utf-8,';
  const arrData = dataArray;
  csvContent += [
    Object.keys(arrData[0]).join(','),
    ...arrData.map(item => {
      return '"' + Object.values(item).join('","') + '"';
    }),
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '');

  const data = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  link.click();
}

export function download_table_as_csv(table_id, separator = ',') {
  // Select rows from table_id
  let rows = document.querySelectorAll('table#' + table_id + ' tr');
  // Construct csv
  let csv = [];
  for (let i = 0; i < rows.length; i++) {
    let row = [],
      cols = rows[i].querySelectorAll('td, th');
    for (let col = 0; col < cols.length; col++) {
      // Clean innertext to remove multiple spaces and jumpline (break csv)
      let data = cols[col].innerText
        .replace(/(\r\n|\n|\r)/gm, '')
        .replace(/(\s\s)/gm, ' ');
      // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
      data = data.replace(/"/g, '""');
      // Push escaped string
      row.push('"' + data + '"');
    }
    csv.push(row.join(separator));
  }
  let csv_string = csv.join('\n');
  // Download it
  let filename = 'export_' + table_id + '_' + new Date().toLocaleDateString() + '.csv';
  let link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('target', '_blank');
  link.setAttribute(
    'href',
    'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string),
  );
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function download_reo_matrix_as_excel(
  table_id,
  applied_filters,
  separator = ',',
) {
  // Select rows from table_id
  let rows = document.querySelectorAll('table#' + table_id + ' tr');
  // Construct csv
  let csv = [];
  for (let i = 0; i < rows.length; i++) {
    let row = [],
      cols = rows[i].querySelectorAll('td, th');
    for (let col = 0; col < cols.length; col++) {
      // Clean innertext to remove multiple spaces and jumpline (break csv)
      let data = cols[col].innerText
        .replace(/(\r\n|\n|\r)/gm, '')
        .replace(/(\s\s)/gm, ' ');
      // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
      data = data.replace(/"/g, '""');
      // Push escaped string
      row.push('"' + data + '"');
    }
    csv.push(row.join(separator));
  }
  let csv_string = csv.join('\n');
  let data = {csv_string: csv_string, applied_filters: applied_filters};

  // Download it
  axios({
    method: 'post',
    baseURL: this.$store.getters.baseUrl,
    url: 'reo_matrix_to_excel/',
    responseType: 'blob',
    data: data,
  })
    .then(response => {
      let extra_text = '';
      const filename = `${table_id}${extra_text}.xlsx`;
      FileDownload(response.data, filename);
      swal('REO Matrix downloaded to downloads folder.', {
        buttons: false,
        timer: 2000,
      });
    })
    .catch(e => {
      handle_error({
        code: 'html_to_xls_download_error',
        message: e.message,
      });
    });
}
